(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-size-purchase"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-multi-size-purchase]');

    sections.forEach((section) => {
      const selections = new Map();
      const selection = section.querySelector('[data-selection]');
      const selectedItems = section.querySelector('[data-selected-items]');
      const total = section.querySelector('[data-total]');
      const submit = section.querySelector('[data-submit]');
      const error = section.querySelector('[data-error]');
      const buttons = section.querySelectorAll('[data-size-button]');
      const galleryTrack = section.querySelector('[data-gallery-track]');
      const gallerySlides = section.querySelectorAll('[data-gallery-slide]');
      const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');

      galleryThumbs.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = Number(thumbnail.dataset.galleryIndex);
          const slide = gallerySlides[index];
          if (!slide) return;
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          galleryThumbs.forEach((item) => {
            const active = item === thumbnail;
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
            item.style.borderColor = active ? '#f4f4f2' : '#555';
          });
        });
      });

      if (!selection || !selectedItems || !total || !submit || !error) return;

      let currentSizeSystem = section.dataset.sizeSystem || 'jp';
      const render = () => {
        const values = Array.from(selections.values());
        const quantity = values.reduce((sum, item) => sum + item.quantity, 0);
        selectedItems.innerHTML = '';
        values.forEach((item) => {
          const row = document.createElement('div');
          const title = document.createElement('span');
          const quantityControls = document.createElement('div');
          const decrease = document.createElement('button');
          const quantityOutput = document.createElement('output');
          const increase = document.createElement('button');
          row.className = 'multi-size-purchase__selected-item';
          const sizeButton = Array.from(buttons).find((button) => button.dataset.variantId === item.id);
          const displaySize = sizeButton && sizeButton.dataset['size' + currentSizeSystem.charAt(0).toUpperCase() + currentSizeSystem.slice(1)];
          const orderSize = `JP ${item.title} cm`;
          const sizeTitle = displaySize && currentSizeSystem !== 'jp' ? `${displaySize} (${orderSize})` : orderSize;
          title.textContent = section.dataset.english === 'true' ? sizeTitle : item.title;
          quantityControls.className = 'multi-size-purchase__quantity';
          decrease.type = 'button';
          decrease.textContent = '−';
          decrease.setAttribute('aria-label', section.dataset.english === 'true' ? `Decrease quantity for JP ${item.title} cm` : `${item.title}の数量を減らす`);
          decrease.dataset.decrease = item.id;
          quantityOutput.textContent = item.quantity;
          increase.type = 'button';
          increase.textContent = '＋';
          increase.setAttribute('aria-label', section.dataset.english === 'true' ? `Increase quantity for JP ${item.title} cm` : `${item.title}の数量を増やす`);
          increase.dataset.increase = item.id;
          quantityControls.append(decrease, quantityOutput, increase);
          row.append(title, quantityControls);
          selectedItems.appendChild(row);
        });
        selection.hidden = values.length === 0;
        total.value = quantity;
        total.textContent = quantity;
        submit.disabled = quantity === 0 || section.dataset.countryPending === 'true' || section.dataset.cartPending === 'true';
        const cost = section.querySelector('[data-order-cost]');
        if (cost && section.dataset.countryPending !== 'true') {
          const count = quantity || 1;
          const currency = cost.dataset.currency;
          const format = new Intl.NumberFormat('en', {style:'currency', currency, currencyDisplay:'narrowSymbol'});
          const money = (amount) => {
            const formatted = format.format(amount);
            return formatted.includes(currency) ? formatted : formatted + ' ' + currency;
          };
          const subtotal = Number(cost.dataset.unitPrice) * count / 100;
          cost.querySelector('[data-cost-products]').textContent = money(subtotal);
          cost.querySelector('[data-cost-total]').textContent = money(subtotal + Number(cost.dataset.shipping) / 100);
          cost.querySelector('.neulo-order-cost__heading').textContent = `Total for ${count} ${count === 1 ? 'pair' : 'pairs'}`;
        }
      };

      const sizeControls = section.querySelectorAll('[data-neulo-size-system-button]');
      const updateSizeDisplay = (system) => {
        currentSizeSystem = system;
        sizeControls.forEach((control) => control.setAttribute('aria-pressed', control.dataset.neuloSizeSystemButton === system ? 'true' : 'false'));
        buttons.forEach((button) => {
          const label = button.querySelector('[data-neulo-size-label]');
          const value = button.dataset['size' + system.charAt(0).toUpperCase() + system.slice(1)];
          if (label && value) label.textContent = value;
        });
        render();
      };
      if (section.dataset.english === 'true') {
        updateSizeDisplay(section.dataset.sizeSystem || 'jp');
        sizeControls.forEach((control) => control.addEventListener('click', () => updateSizeDisplay(control.dataset.neuloSizeSystemButton)));
        section.addEventListener('neulo:country-preview', (event) => {
          updateSizeDisplay(event.detail.sizeSystem);
        });
        section.addEventListener('neulo:country-updated', () => {
          selections.forEach((item, id) => {
            const button = Array.from(buttons).find((candidate) => candidate.dataset.variantId === id);
            if (!button || button.disabled) {
              selections.delete(id);
              if (button) button.setAttribute('aria-pressed', 'false');
            }
          });
          render();
        });
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.variantId;
          if (!id || button.disabled) return;
          if (selections.has(id)) return;
          selections.set(id, { id, title: button.dataset.variantTitle || '', quantity: 1 });
          button.setAttribute('aria-pressed', 'true');
          render();
        });
      });

      selectedItems.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLButtonElement)) return;
        const id = target.dataset.increase || target.dataset.decrease;
        const item = id ? selections.get(id) : null;
        if (!item) return;
        if (target.dataset.increase) item.quantity += 1;
        if (target.dataset.decrease) item.quantity -= 1;
        if (item.quantity <= 0) {
          selections.delete(item.id);
          const sizeButton = section.querySelector(`[data-variant-id="${item.id}"]`);
          if (sizeButton) sizeButton.setAttribute('aria-pressed', 'false');
        }
        render();
      });

      submit.addEventListener('click', async () => {
        if (selections.size === 0 || section.dataset.countryPending === 'true' || section.dataset.cartPending === 'true') return;
        section.dataset.cartPending = 'true';
        document.querySelectorAll('[data-neulo-country-select]').forEach((select) => { select.disabled = true; });
        submit.disabled = true;
        error.hidden = true;
        try {
          const response = await fetch(section.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: Array.from(selections.values()).map((item) => ({ id: item.id, quantity: item.quantity, ...(section.dataset.international === 'true' ? {properties:{'International delivery':'Duties, import taxes and customs fees paid by NEULO.'}} : {}) })) })
          });
          if (!response.ok) throw new Error();
          window.location.assign(section.dataset.cartUrl);
        } catch (exception) {
          delete section.dataset.cartPending;
          document.querySelectorAll('[data-neulo-country-select]').forEach((select) => { select.disabled = false; });
          error.textContent = section.dataset.cartError;
          error.hidden = false;
          render();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
